var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingPageShareIcon = function SvgLandingPageShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LandingPageShareIcon_svg__a)",
    fillRule: "evenodd",
    d: "M29.657 16.328c0 7.361-5.968 13.329-13.329 13.329C8.968 29.657 3 23.689 3 16.328 3 8.968 8.967 3 16.328 3s13.329 5.967 13.329 13.328m3 0c0 9.018-7.31 16.329-16.329 16.329C7.31 32.657 0 25.347 0 16.328 0 7.31 7.31 0 16.328 0s16.329 7.31 16.329 16.328M33.5 38.95l3-2.439 2.999-2.438 2.378-1.933-2.378-1.933-2.999-2.438-3-2.438v3.891c-4.736.55-7.942 2.344-10.05 4.678-1.622 1.794-2.594 3.908-3.114 6.022a13.3 13.3 0 0 1 4.954-3.556c1.533-.64 3.26-1.056 5.21-1.258a29 29 0 0 1 3-.147v3.989m3.621-6.81-.62.505v-.684h-.583l.582-.067v-.258z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LandingPageShareIcon_svg__a",
    x1: 0,
    x2: 37.026,
    y1: 0,
    y2: 46.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#fff",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgLandingPageShareIcon;